import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import HorizontalScroll from '@components/HorizontalScroll';

import InfluencerFilterLeftSidePanel from '@features/trend-research/components/onboarding/components/InfluencerFilterLeftSidePanel';
import TrendTopFilter from '@features/trend-research/components/onboarding/components/TrendTopFilter';

import { toggleInstagramInfluencer } from '@store/actions/trend-research/TrendResearchAction';
import {
	useInstagramInfluencer,
	useSelectedInluencers
} from '@store/reducers/trend-research/TrendResearchReducer';

const Influencers = () => {
	const dispatch = useDispatch();
	const scrollRef = useRef(null);
	const influencerList = useInstagramInfluencer();
	const selectedInfluencers = useSelectedInluencers();
	const [isShowFilter, setIsShowFilter] = useState(false);
	const listOfInfluencer = influencerList.filter((user) => selectedInfluencers.includes(user.userName));

	const toggleIsShowFilter = () => {
		setIsShowFilter(false);
	};

	const totalInfluencerWiseProducts = influencerList?.reduce(
		(total, item) => (total += item.noOfProducts),
		0
	);

	const renderInfluencers = () => {
		const toggleInfluencerSelection = (userName) => {
			dispatch(toggleInstagramInfluencer(userName));
		};

		return listOfInfluencer?.map((item, idx) => {
			return (
				<div
					className="instagram-single d-flex align-items-center radius-4"
					key={`instagram_influencer_${idx}`}
				>
					<div className="img">
						<img src={item.profilePicUrl} alt="" />
					</div>
					<div className="content pl-1">
						<p className="regular-12 gray_dark_01 weight-500 pb-1">{item?.userName}</p>
						<p className="regular-12 gray_dark_01 weight-500">{item?.noOfProducts} Products</p>
					</div>
					<div className="overly radius-4 d-flex align-items-center align-self-center flex-column justify-content-center">
						<div
							className="close-img cursor-pointer d-flex justify-content-center align-items-center"
							onClick={() => toggleInfluencerSelection(item.userName)}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} width={20} alt="" />
						</div>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="brand-section instagram-section">
			<TrendTopFilter title="Influencers" type="Instagram" />
			<div className="d-flex">
				<div className="brand-select-btn mr-3 cursor-pointer">
					<div className="brand-single d-flex align-items-center align-self-center flex-column justify-content-center">
						<div onClick={() => setIsShowFilter(true)}>
							<p className="mb-12 d-flex">
								Select Influencer
								<span>
									<img src={`${process.env.PUBLIC_URL}/icons/right-arrow.svg`} alt="" />
								</span>
							</p>
							<p className="regular-12 gray_dark_01">{totalInfluencerWiseProducts} Products</p>
						</div>
					</div>
				</div>
				<div className="d-flex brand-items trending-slider scroll-x-label" ref={scrollRef}>
					{listOfInfluencer.length > 0 && <HorizontalScroll elementReference={scrollRef.current} />}
					{renderInfluencers()}
				</div>
			</div>
			<InfluencerFilterLeftSidePanel
				toggleIsShowFilter={toggleIsShowFilter}
				isShowFilter={isShowFilter}
				influencerList={influencerList}
			/>
		</div>
	);
};

export default Influencers;
